import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-536741f9"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-bg"
}, null, -1));

const _hoisted_3 = {
  class: "owin-height"
};
const _hoisted_4 = {
  class: "teacher-top"
};
const _hoisted_5 = {
  class: "teacher-main-title"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line-icon"
}, null, -1));

const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = {
  class: "show-type"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-suolvetu"
}, null, -1));

const _hoisted_10 = [_hoisted_9];

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-daohangguanli"
}, null, -1));

const _hoisted_12 = [_hoisted_11];
const _hoisted_13 = {
  class: "teacher-wrapper"
};
const _hoisted_14 = {
  class: "category-list"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode("荣誉称号");

const _hoisted_16 = {
  class: "category-title"
};
const _hoisted_17 = {
  class: "count"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode("归属学院");

const _hoisted_19 = {
  class: "category-title"
};
const _hoisted_20 = {
  class: "count"
};
const _hoisted_21 = {
  key: 1,
  class: "teacher-box"
};
const _hoisted_22 = {
  key: 0,
  class: "teacher-list"
};
const _hoisted_23 = {
  key: 1,
  class: "empty-box"
};
const _hoisted_24 = {
  key: 2,
  class: "teacher-box"
};
const _hoisted_25 = {
  key: 0,
  class: "teacher-list2"
};
const _hoisted_26 = ["onClick"];

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dot"
}, null, -1));

const _hoisted_28 = {
  class: "teacher-name text-overflow"
};
const _hoisted_29 = {
  key: 1,
  class: "empty-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_menu_item = _resolveComponent("el-menu-item");

  const _component_el_sub_menu = _resolveComponent("el-sub-menu");

  const _component_el_menu = _resolveComponent("el-menu");

  const _component_el_affix = _resolveComponent("el-affix");

  const _component_TeacherCard = _resolveComponent("TeacherCard");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event)
  }, null, 8, ["menuInfo"]), _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString($data.menuInfo.nav_name) + "  ", 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
    class: _normalizeClass(["suoluotu", $data.showType == 1 ? 'active' : '']),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.showType1 && $options.showType1(...args))
  }, _hoisted_10, 2), _createElementVNode("span", {
    class: _normalizeClass($data.showType == 2 ? 'active' : ''),
    onClick: _cache[2] || (_cache[2] = (...args) => $options.showType2 && $options.showType2(...args))
  }, _hoisted_12, 2)])]), _createVNode(_component_el_input, {
    modelValue: $data.teacherName,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.teacherName = $event),
    size: "default",
    class: "search-input",
    onKeyup: _withKeys($options.handleSearch, ["enter"]),
    placeholder: "搜索教师名称"
  }, {
    suffix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[3] || (_cache[3] = (...args) => $options.handleSearch && $options.handleSearch(...args))
    })]),
    _: 1
  }, 8, ["modelValue", "onKeyup"])]), _createElementVNode("div", _hoisted_13, [$data.organ_flag.indexOf('1') > -1 || $data.organ_flag.indexOf('2') > -1 ? (_openBlock(), _createBlock(_component_el_affix, {
    key: 0,
    offset: 0
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [$data.organ_flag.indexOf('1') > -1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 0,
      "default-active": $data.searchInfo.titleId,
      "default-openeds": ['1']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "1"
      }, {
        title: _withCtx(() => [_hoisted_15]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherTitleList, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.titleId == item.honorary_title_id ? 'active-tag' : '']),
            index: item.honorary_title_id + '',
            key: item.honorary_title_id,
            onClick: $event => $options.teacherTitleChange(item)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_16, _toDisplayString(item.honorary_title_name), 1), _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(item.count) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreTeacherTitle || index < 6]]);
        }), 128)), $data.teacherTitleList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[5] || (_cache[5] = (...args) => $options.toggleShowTeacherTitle && $options.toggleShowTeacherTitle(...args))
        }, _toDisplayString($data.showMoreTeacherTitle ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true), $data.organ_flag.indexOf('2') > -1 ? (_openBlock(), _createBlock(_component_el_menu, {
      key: 1,
      "default-active": $data.searchInfo.collegeId,
      "default-openeds": ['2']
    }, {
      default: _withCtx(() => [_createVNode(_component_el_sub_menu, {
        index: "2"
      }, {
        title: _withCtx(() => [_hoisted_18]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.collegeList, ({
          organ_name,
          organ_id,
          count = 0
        }, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
            class: _normalizeClass(["category-item", $data.searchInfo.collegeId == organ_id ? 'active-tag' : '']),
            index: organ_id + '',
            key: index,
            onClick: $event => $options.collegeChange(organ_id, organ_name)
          }, {
            default: _withCtx(() => [_createElementVNode("span", _hoisted_19, _toDisplayString(organ_name), 1), _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(count) + ")", 1)]),
            _: 2
          }, 1032, ["class", "index", "onClick"])), [[_vShow, $data.showMoreCollege || index < 6]]);
        }), 128)), $data.collegeList.length > 6 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "category-btn",
          onClick: _cache[6] || (_cache[6] = (...args) => $options.toggleShowCollege && $options.toggleShowCollege(...args))
        }, _toDisplayString($data.showMoreCollege ? '-' : '+'), 1)) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["default-active"])) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true), $data.showType == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [$data.teacherList && $data.teacherList.length ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherList, teacher => {
    return _openBlock(), _createBlock(_component_TeacherCard, {
      "teacher-data": teacher,
      key: teacher.id
    }, null, 8, ["teacher-data"]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "teacher-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.showType == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [$data.teacherList && $data.teacherList.length ? (_openBlock(), _createElementBlock("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teacherList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["teacher-card-list", $data.organ_flag.indexOf('1') == -1 && $data.organ_flag.indexOf('2') == -1 ? '' : 'teacher-card-list2']),
      key: item.id,
      onClick: $event => $options.goDetail(item.id)
    }, [_hoisted_27, _createElementVNode("span", _hoisted_28, _toDisplayString(item.teacher_name), 1)], 10, _hoisted_26);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_Empty, {
    text: "暂无数据"
  })])), $data.pageInfo.rows && $data.pageInfo.rows > $data.pageInfo.pageLimit2 ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 2,
    class: "teacher-pagination",
    background: "",
    layout: "prev, pager, next",
    "prev-text": "上一页",
    "next-text": "下一页",
    onCurrentChange: $options.pageIndexChange,
    "current-page": $data.pageInfo.pageIndex,
    total: $data.pageInfo.rows,
    "page-size": $data.pageInfo.pageLimit2
  }, null, 8, ["onCurrentChange", "current-page", "total", "page-size"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]), _createVNode(_component_Footer)]);
}